import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface Props {
  gap?: number;
}

const gapCss = (props: Props) => css`
  display: flex;
  flex-direction: column;
  gap: ${props.gap !== undefined ? `${props.gap}px` : 'var(--spacing-xxl)'};
`;

const Stack = styled.div<Props>`
  ${gapCss}
`;

export default Stack;
